/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("NavigationService", ["InitService", "HostService", "SessionService"], function (context, cls) {
  /**
   * Service that ease the Application/window navigation
   * @namespace gbc.NavigationService
   * @gbcService
   * @publicdoc
   */
  class NavigationService /** @lends gbc.NavigationService */ {
    constructor() {
      /**
       * @type {classes.EventListener}
       */
      this._eventListener = null;
      this._newRootApplicationEvent = "gbc.NavigationService.newRootApplication";
    }

    /**
     * Initialize the navigation Service
     */
    init() {
      this._eventListener = new cls.EventListener();

      gbc.HostService.onCurrentWindowChange(() => {
        const session = gbc.SessionService.getCurrent();
        session.getNavigationManager().onApplicationAdded((event, invoker, application) => {
          this._eventListener.emit(this._newRootApplicationEvent, application);
        });
      }, true);
    }

    /**
     * Run the new application
     * @param {string} applicationId appId defined in the XCF file
     * @param onFailure callback in case of failure
     */
    newRootApplication(applicationId, onFailure) {
      const application = gbc.SessionService.getCurrent().getCurrentApplication();
      application.protocolInterface.runApplication(application, applicationId, onFailure);
    }

    /**
     * Event raised when a new application is created. Callback syntax: fn(application)
     * @param {function} callback function syntaxe: fn(VMApplication)
     * @return {HandleRegistration}
     */
    onNewRootApplication(callback) {
      return this._eventListener.when(this._newRootApplicationEvent, function (event) {
        callback(event.data[0]);
      });
    }

    /**
     * Get all the root applications
     * @return {classes.VMApplication[]}
     */
    getRootApplicationList() {
      const res = new Set();
      const navigationManager = gbc.SessionService.getCurrent().getNavigationManager();
      const appList = navigationManager.getApplications();

      appList.forEach((app) => {
        res.add(navigationManager.getRootWaitingApplication(app));
      });

      return Array.from(res);
    }

    /**
     * Get the current root application
     * @return {classes.VMApplication}
     */
    getCurrentRootApplication() {
      const session = gbc.SessionService.getCurrent();
      const navigationManager = session.getNavigationManager();

      return navigationManager.getRootWaitingApplication(session.getCurrentApplication());
    }

    /**
     * Show the active window of the application
     * @param {classes.VMApplication} application
     */
    setForegroundApplication(application) {
      application.getSession().getNavigationManager().goBackToLastActiveWindow(application);
    }

    /**
     * Close the current application
     */
    closeApplication() {
      gbc.SessionService.getCurrent().getCurrentApplication().close();
    }
  }

  gbc.NavigationService = new NavigationService();

  context.InitService.register(context.NavigationService);
});
